(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function footerBlockLinkListClickHeading() {
    const footerBlockLinkListHeading = document.querySelectorAll('.footer_menus_wrapper .footer-block__heading');
    footerBlockLinkListHeading.forEach((heading) => {
      heading.addEventListener('click', () => {
        heading.parentElement.classList.toggle('active');
      });
    });
  }
  document.addEventListener('DOMContentLoaded', footerBlockLinkListClickHeading);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.resizeTimeout = null;
      this.lastKnownHeight = null;
      this.initialHeightSet = false;

      // CLS Optimization: Set initial height immediately to prevent any shift
      this.setInitialHeaderHeight();

      // CLS Optimization: Use ResizeObserver instead of resize events for better performance
      this.initializeResizeObserver();

      // CLS Optimization: Debounced media query handler
      const debouncedSetHeight = this.debounce(() => {
        this.setHeaderHeight();
      }, 150); // Slightly longer debounce for better performance

      window.matchMedia('(max-width: 990px)').addEventListener('change', debouncedSetHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    // CLS Optimization: Set initial height immediately without measuring
    setInitialHeaderHeight() {
      // Use the CSS-calculated initial height to avoid any layout shift
      const initialHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height-initial').trim();
      this.lastKnownHeight = parseInt(initialHeight);
      this.initialHeightSet = true;
    }

    // CLS Optimization: Initialize ResizeObserver for efficient resize handling
    initializeResizeObserver() {
      if (!window.ResizeObserver) {
        // Fallback for browsers without ResizeObserver support
        window.addEventListener('resize', this.debounce(() => {
          this.setHeaderHeight();
        }, 150));
        return;
      }

      this.resizeObserver = new ResizeObserver(entries => {
        // Use requestAnimationFrame to batch updates
        requestAnimationFrame(() => {
          this.setHeaderHeight();
        });
      });

      // Observe the header for size changes
      this.resizeObserver.observe(this.header);
    }

    setHeaderHeight() {
      // CLS Optimization: Only update if height actually changed to prevent unnecessary reflows
      const currentHeight = this.header.offsetHeight;
      
      // Skip if height hasn't changed significantly (allow 1px tolerance for subpixel rendering)
      if (Math.abs(this.lastKnownHeight - currentHeight) <= 1) {
        return;
      }

      this.lastKnownHeight = currentHeight;
      
      // Use requestAnimationFrame to batch DOM writes and prevent layout thrashing
      requestAnimationFrame(() => {
        // CLS Optimization: Only update if the difference is significant enough to matter
        const currentCSSHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
        if (Math.abs(currentCSSHeight - currentHeight) > 2) {
          document.documentElement.style.setProperty('--header-height', `${currentHeight}px`);
        }
      });
    }

    // CLS Optimization: Debounce utility to prevent excessive function calls
    debounce(func, wait) {
      return (...args) => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => func.apply(this, args), wait);
      };
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      
      // CLS Optimization: Clean up ResizeObserver and timeouts to prevent memory leaks
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
      
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cwb-before-after"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (!window.__cwbFadeInit) {
    window.__cwbFadeInit = true;
    var io0 = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('cwb-visible'); io0.unobserve(e.target); }
      });
    }, {threshold: 0.15, rootMargin: '0px 0px -40px 0px'});
    document.querySelectorAll('.cwb-animate:not(.cwb-visible)').forEach(function(el){ io0.observe(el); });
  }

  document.querySelectorAll('[data-cwb-ba]').forEach(function(item){
    var frame = item.querySelector('.cwb-ba__frame');
    var before = item.querySelector('[data-cwb-ba-before]');
    var handle = item.querySelector('[data-cwb-ba-handle]');
    var dragging = false;

    function setPos(pct){
      pct = Math.max(0, Math.min(100, pct));
      before.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.style.left = pct + '%';
      handle.setAttribute('aria-valuenow', Math.round(pct));
    }

    function fromEvent(e){
      var rect = frame.getBoundingClientRect();
      var x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
      return (x / rect.width) * 100;
    }

    handle.addEventListener('pointerdown', function(e){ dragging = true; handle.setPointerCapture(e.pointerId); });
    frame.addEventListener('pointermove', function(e){ if (dragging) setPos(fromEvent(e)); });
    handle.addEventListener('pointerup', function(){ dragging = false; });
    handle.addEventListener('pointercancel', function(){ dragging = false; });
    frame.addEventListener('click', function(e){ if (e.target === handle || handle.contains(e.target)) return; setPos(fromEvent(e)); });

    handle.addEventListener('keydown', function(e){
      var current = parseFloat(handle.getAttribute('aria-valuenow')) || 50;
      if (e.key === 'ArrowLeft') { setPos(current - 5); e.preventDefault(); }
      if (e.key === 'ArrowRight') { setPos(current + 5); e.preventDefault(); }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cwb-comparison-table"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (!window.__cwbFadeInit) {
    window.__cwbFadeInit = true;
    var io0 = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('cwb-visible'); io0.unobserve(e.target); }
      });
    }, {threshold: 0.15, rootMargin: '0px 0px -40px 0px'});
    document.querySelectorAll('.cwb-animate:not(.cwb-visible)').forEach(function(el){ io0.observe(el); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cwb-faq"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (!window.__cwbFadeInit) {
    window.__cwbFadeInit = true;
    var io0 = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('cwb-visible'); io0.unobserve(e.target); }
      });
    }, {threshold: 0.15, rootMargin: '0px 0px -40px 0px'});
    document.querySelectorAll('.cwb-animate:not(.cwb-visible)').forEach(function(el){ io0.observe(el); });
  }

  document.querySelectorAll('[data-cwb-faq-trigger]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var panel = btn.nextElementSibling;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      btn.closest('.cwb-faq__item').classList.toggle('is-open', !open);
      panel.style.maxHeight = open ? null : panel.scrollHeight + 'px';
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cwb-feature-highlights"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (!window.__cwbFadeInit) {
    window.__cwbFadeInit = true;
    var io0 = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('cwb-visible'); io0.unobserve(e.target); }
      });
    }, {threshold: 0.15, rootMargin: '0px 0px -40px 0px'});
    document.querySelectorAll('.cwb-animate:not(.cwb-visible)').forEach(function(el){ io0.observe(el); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cwb-final-cta"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (!window.__cwbFadeInit) {
    window.__cwbFadeInit = true;
    var io0 = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('cwb-visible'); io0.unobserve(e.target); }
      });
    }, {threshold: 0.15, rootMargin: '0px 0px -40px 0px'});
    document.querySelectorAll('.cwb-animate:not(.cwb-visible)').forEach(function(el){ io0.observe(el); });
  }
  if (!window.__cwbScrollToInit) {
    window.__cwbScrollToInit = true;
    document.addEventListener('click', function(e){
      var btn = e.target.closest('[data-cwb-scroll-to]');
      if (!btn) return;
      var target = document.getElementById(btn.getAttribute('data-cwb-scroll-to'));
      if (target) target.scrollIntoView({behavior:'smooth', block:'start'});
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cwb-guarantee"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (!window.__cwbFadeInit) {
    window.__cwbFadeInit = true;
    var io0 = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('cwb-visible'); io0.unobserve(e.target); }
      });
    }, {threshold: 0.15, rootMargin: '0px 0px -40px 0px'});
    document.querySelectorAll('.cwb-animate:not(.cwb-visible)').forEach(function(el){ io0.observe(el); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cwb-hero-gallery"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (!window.__cwbFadeInit) {
    window.__cwbFadeInit = true;
    var io0 = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('cwb-visible'); io0.unobserve(e.target); }
      });
    }, {threshold: 0.15, rootMargin: '0px 0px -40px 0px'});
    document.querySelectorAll('.cwb-animate:not(.cwb-visible)').forEach(function(el){ io0.observe(el); });
  }

  document.querySelectorAll('[data-cwb-hero-main]').forEach(function(main){
    var slides = Array.prototype.slice.call(main.querySelectorAll('[data-cwb-slide]'));
    var root = main.closest('.cwb-hero');
    var thumbs = root.querySelectorAll('[data-cwb-thumb]');
    var current = 0;

    function setActive(i){
      current = i;
      slides.forEach(function(s,idx){ s.classList.toggle('is-active', idx===i); });
      thumbs.forEach(function(t,idx){ t.classList.toggle('is-active', idx===i); t.setAttribute('aria-selected', idx===i); });
    }

    function goTo(i){
      i = (i + slides.length) % slides.length;
      var target = slides[i];
      if (target) target.scrollIntoView({behavior:'smooth', inline:'start', block:'nearest'});
    }

    thumbs.forEach(function(t){
      t.addEventListener('click', function(){ goTo(parseInt(t.getAttribute('data-cwb-thumb'), 10)); });
    });

    var prevBtn = root.querySelector('[data-cwb-arrow-prev]');
    var nextBtn = root.querySelector('[data-cwb-arrow-next]');
    if (prevBtn) prevBtn.addEventListener('click', function(){ goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function(){ goTo(current + 1); });

    if (slides.length) {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting && e.intersectionRatio > 0.6) {
            var i = parseInt(e.target.getAttribute('data-cwb-slide'), 10);
            setActive(i);
          }
        });
      }, {root: main, threshold: 0.6});
      slides.forEach(function(s){ io.observe(s); });
    }

    var lightbox = root.querySelector('[data-cwb-lightbox]');
    var lightboxImg = lightbox ? lightbox.querySelector('[data-cwb-lightbox-img]') : null;

    function openLightbox(i){
      if (!lightbox || !lightboxImg) return;
      var img = slides[i].querySelector('img');
      if (!img) return;
      lightboxImg.src = img.getAttribute('data-full') || img.src;
      lightboxImg.alt = img.alt;
      lightbox.hidden = false;
      lightbox.setAttribute('data-open-index', i);
      document.body.style.overflow = 'hidden';
    }
    function closeLightbox(){
      if (!lightbox) return;
      lightbox.hidden = true;
      document.body.style.overflow = '';
    }

    root.querySelectorAll('[data-cwb-zoomable]').forEach(function(img){
      img.addEventListener('click', function(){
        var i = parseInt(img.closest('[data-cwb-slide]').getAttribute('data-cwb-slide'), 10);
        openLightbox(i);
      });
    });
    var expandBtn = root.querySelector('[data-cwb-lightbox-open]');
    if (expandBtn) expandBtn.addEventListener('click', function(){ openLightbox(current); });
    if (lightbox) {
      var closeBtn = lightbox.querySelector('[data-cwb-lightbox-close]');
      var lbPrev = lightbox.querySelector('[data-cwb-lightbox-prev]');
      var lbNext = lightbox.querySelector('[data-cwb-lightbox-next]');
      if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
      lightbox.addEventListener('click', function(e){ if (e.target === lightbox) closeLightbox(); });
      document.addEventListener('keydown', function(e){
        if (lightbox.hidden) return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowLeft') { var idx = (parseInt(lightbox.getAttribute('data-open-index'),10) - 1 + slides.length) % slides.length; openLightbox(idx); }
        if (e.key === 'ArrowRight') { var idx2 = (parseInt(lightbox.getAttribute('data-open-index'),10) + 1) % slides.length; openLightbox(idx2); }
      });
      if (lbPrev) lbPrev.addEventListener('click', function(){ var idx = (parseInt(lightbox.getAttribute('data-open-index'),10) - 1 + slides.length) % slides.length; openLightbox(idx); });
      if (lbNext) lbNext.addEventListener('click', function(){ var idx = (parseInt(lightbox.getAttribute('data-open-index'),10) + 1) % slides.length; openLightbox(idx); });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cwb-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (!window.__cwbFadeInit) {
    window.__cwbFadeInit = true;
    var io0 = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('cwb-visible'); io0.unobserve(e.target); }
      });
    }, {threshold: 0.15, rootMargin: '0px 0px -40px 0px'});
    document.querySelectorAll('.cwb-animate:not(.cwb-visible)').forEach(function(el){ io0.observe(el); });
  }
  if (!window.__cwbScrollToInit) {
    window.__cwbScrollToInit = true;
    document.addEventListener('click', function(e){
      var btn = e.target.closest('[data-cwb-scroll-to]');
      if (!btn) return;
      var target = document.getElementById(btn.getAttribute('data-cwb-scroll-to'));
      if (target) target.scrollIntoView({behavior:'smooth', block:'start'});
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cwb-how-it-works"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (!window.__cwbFadeInit) {
    window.__cwbFadeInit = true;
    var io0 = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('cwb-visible'); io0.unobserve(e.target); }
      });
    }, {threshold: 0.15, rootMargin: '0px 0px -40px 0px'});
    document.querySelectorAll('.cwb-animate:not(.cwb-visible)').forEach(function(el){ io0.observe(el); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cwb-image-feature"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (!window.__cwbFadeInit) {
    window.__cwbFadeInit = true;
    var io0 = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('cwb-visible'); io0.unobserve(e.target); }
      });
    }, {threshold: 0.15, rootMargin: '0px 0px -40px 0px'});
    document.querySelectorAll('.cwb-animate:not(.cwb-visible)').forEach(function(el){ io0.observe(el); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cwb-key-benefits"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (!window.__cwbFadeInit) {
    window.__cwbFadeInit = true;
    var io0 = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('cwb-visible'); io0.unobserve(e.target); }
      });
    }, {threshold: 0.15, rootMargin: '0px 0px -40px 0px'});
    document.querySelectorAll('.cwb-animate:not(.cwb-visible)').forEach(function(el){ io0.observe(el); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cwb-lifestyle"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (!window.__cwbFadeInit) {
    window.__cwbFadeInit = true;
    var io0 = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('cwb-visible'); io0.unobserve(e.target); }
      });
    }, {threshold: 0.15, rootMargin: '0px 0px -40px 0px'});
    document.querySelectorAll('.cwb-animate:not(.cwb-visible)').forEach(function(el){ io0.observe(el); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cwb-numbered-cards"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (!window.__cwbFadeInit) {
    window.__cwbFadeInit = true;
    var io0 = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('cwb-visible'); io0.unobserve(e.target); }
      });
    }, {threshold: 0.15, rootMargin: '0px 0px -40px 0px'});
    document.querySelectorAll('.cwb-animate:not(.cwb-visible)').forEach(function(el){ io0.observe(el); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cwb-product-info"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-cwb-product-form]').forEach(function(form){
    var root = form.closest('.cwb-info');
    var variantsEl = root.querySelector('[data-cwb-variants]');
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var selects = form.querySelectorAll('[data-cwb-option-index]');
    var hiddenId = form.querySelector('[data-cwb-variant-id]');
    var priceEl = root.querySelector('[data-cwb-price]');
    var atc = root.querySelector('[data-cwb-atc]');
    var atcText = root.querySelector('[data-cwb-atc-text]');
    var stockEl = root.querySelector('[data-cwb-stock]');
    var errorEl = root.querySelector('[data-cwb-error]');

    function currentOptions(){
      var vals = [];
      selects.forEach(function(s){ vals[parseInt(s.getAttribute('data-cwb-option-index'),10)] = s.value; });
      return vals;
    }

    function findVariant(){
      var opts = currentOptions();
      return variants.filter(function(v){
        return opts.every(function(val, i){ return val === undefined || v.options[i] === val; });
      })[0];
    }

    function formatMoney(cents){
      return (cents / 100).toLocaleString(document.documentElement.lang || undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
    }

    function updateUI(v){
      if (!v) return;
      hiddenId.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (atc) atc.disabled = !v.available;
      if (atcText) atcText.textContent = v.available ? 'Add to Cart' : 'Sold Out';
      if (stockEl) {
        stockEl.innerHTML = !v.available
          ? '<span class="cwb-info__stock-dot is-out"></span> Sold out'
          : '<span class="cwb-info__stock-dot is-in"></span> In stock, ready to ship';
      }
    }

    selects.forEach(function(s){
      s.addEventListener('change', function(){
        var v = findVariant();
        updateUI(v);
        if (v) document.dispatchEvent(new CustomEvent('cwb:variant-select', { detail: { id: v.id, source: 'product-info' } }));
      });
    });

    document.addEventListener('cwb:variant-select', function(e){
      if (e.detail && e.detail.source === 'product-info') return;
      var v = variants.filter(function(vv){ return String(vv.id) === String(e.detail.id); })[0];
      if (!v) return;
      v.options.forEach(function(optVal, i){
        var sel = form.querySelector('[data-cwb-option-index="' + i + '"]');
        if (sel) sel.value = optVal;
      });
      updateUI(v);
    });

    var qtyRoot = form.querySelector('[data-cwb-qty]');
    if (qtyRoot) {
      var input = qtyRoot.querySelector('[data-cwb-qty-input]');
      qtyRoot.querySelector('[data-cwb-qty-minus]').addEventListener('click', function(){
        input.value = Math.max(1, (parseInt(input.value,10) || 1) - 1);
      });
      qtyRoot.querySelector('[data-cwb-qty-plus]').addEventListener('click', function(){
        input.value = (parseInt(input.value,10) || 1) + 1;
      });
    }

    form.addEventListener('submit', function(e){
      var submitter = e.submitter || document.activeElement;
      var isBuyNow = submitter && submitter.getAttribute('name') === 'checkout';
      if (isBuyNow) return;

      e.preventDefault();
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      if (atc) atc.disabled = true;
      if (atcText) atcText.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: hiddenId.value,
          quantity: parseInt((qtyRoot ? qtyRoot.querySelector('[data-cwb-qty-input]').value : 1), 10) || 1
        })
      })
        .then(function(res){
          return res.json().then(function(data){ return { ok: res.ok, data: data }; });
        })
        .then(function(result){
          if (!result.ok) throw new Error(result.data && result.data.description || 'Could not add to cart');
          if (atcText) atcText.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(function(){
            if (atcText) atcText.textContent = 'Add to Cart';
            if (atc) atc.disabled = false;
          }, 1600);
        })
        .catch(function(err){
          if (atcText) atcText.textContent = 'Add to Cart';
          if (atc) atc.disabled = false;
          if (errorEl) { errorEl.hidden = false; errorEl.textContent = err.message || 'Something went wrong. Please try again.'; }
        });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cwb-recently-viewed"] && !Shopify.designMode) return;
  try {
    
(function(){
  var STORAGE_KEY = 'cwb_recently_viewed';
  var MAX_ITEMS = 12;

  function getList(){
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; } catch (e) { return []; }
  }
  function saveList(list){
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (e) {}
  }

  document.querySelectorAll('[data-cwb-recent]').forEach(function(section){
    var currentHandle = section.getAttribute('data-current-handle');
    var grid = section.querySelector('[data-cwb-recent-grid]');
    var empty = section.querySelector('[data-cwb-recent-empty]');
    var limit = parseInt(section.getAttribute('data-limit'), 10) || 8;

    var list = getList();
    if (currentHandle) {
      list = list.filter(function(h){ return h !== currentHandle; });
      list.unshift(currentHandle);
      list = list.slice(0, MAX_ITEMS);
      saveList(list);
    }

    var toShow = list.filter(function(h){ return h !== currentHandle; }).slice(0, limit);
    if (!toShow.length) { if (empty) empty.hidden = false; return; }

    Promise.all(toShow.map(function(handle){
      return fetch('/products/' + handle + '.js').then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; });
    })).then(function(products){
      products.filter(Boolean).forEach(function(p){
        var card = document.createElement('a');
        card.href = p.url;
        card.className = 'cwb-recent__card cwb-animate cwb-visible';
        var imgSrc = p.featured_image ? (p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=400') : '';
        var img = imgSrc ? '<img src="' + imgSrc + '" loading="lazy" alt="">' : '';
        var price = (p.price / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
        card.innerHTML = '<div class="cwb-recent__image">' + img + '</div><h3 class="cwb-recent__title"></h3><span class="cwb-recent__price"></span>';
        card.querySelector('.cwb-recent__title').textContent = p.title;
        card.querySelector('.cwb-recent__price').textContent = price;
        grid.appendChild(card);
      });
      if (!grid.children.length && empty) empty.hidden = false;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cwb-related-products"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (!window.__cwbFadeInit) {
    window.__cwbFadeInit = true;
    var io0 = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('cwb-visible'); io0.unobserve(e.target); }
      });
    }, {threshold: 0.15, rootMargin: '0px 0px -40px 0px'});
    document.querySelectorAll('.cwb-animate:not(.cwb-visible)').forEach(function(el){ io0.observe(el); });
  }

  document.querySelectorAll('[data-cwb-related]').forEach(function(section){
    var url = section.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function(res){ return res.text(); })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newSection = doc.querySelector('[data-cwb-related]');
        if (newSection && newSection.innerHTML.trim()) {
          section.innerHTML = newSection.innerHTML;
          section.querySelectorAll('.cwb-animate').forEach(function(el){ el.classList.add('cwb-visible'); });
        }
      })
      .catch(function(){});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cwb-reviews"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (!window.__cwbFadeInit) {
    window.__cwbFadeInit = true;
    var io0 = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('cwb-visible'); io0.unobserve(e.target); }
      });
    }, {threshold: 0.15, rootMargin: '0px 0px -40px 0px'});
    document.querySelectorAll('.cwb-animate:not(.cwb-visible)').forEach(function(el){ io0.observe(el); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cwb-shades"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (!window.__cwbFadeInit) {
    window.__cwbFadeInit = true;
    var io0 = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('cwb-visible'); io0.unobserve(e.target); }
      });
    }, {threshold: 0.15, rootMargin: '0px 0px -40px 0px'});
    document.querySelectorAll('.cwb-animate:not(.cwb-visible)').forEach(function(el){ io0.observe(el); });
  }

  document.querySelectorAll('[data-cwb-shades]').forEach(function(grid){
    grid.querySelectorAll('[data-cwb-shade]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var id = btn.getAttribute('data-variant-id');
        grid.querySelectorAll('[data-cwb-shade]').forEach(function(b){ b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        document.dispatchEvent(new CustomEvent('cwb:variant-select', { detail: { id: id } }));
      });
    });
  });

  document.addEventListener('cwb:variant-select', function(e){
    document.querySelectorAll('[data-cwb-shade]').forEach(function(b){
      b.classList.toggle('is-active', b.getAttribute('data-variant-id') === String(e.detail.id));
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cwb-shipping-returns"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (!window.__cwbFadeInit) {
    window.__cwbFadeInit = true;
    var io0 = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('cwb-visible'); io0.unobserve(e.target); }
      });
    }, {threshold: 0.15, rootMargin: '0px 0px -40px 0px'});
    document.querySelectorAll('.cwb-animate:not(.cwb-visible)').forEach(function(el){ io0.observe(el); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cwb-specifications"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (!window.__cwbFadeInit) {
    window.__cwbFadeInit = true;
    var io0 = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('cwb-visible'); io0.unobserve(e.target); }
      });
    }, {threshold: 0.15, rootMargin: '0px 0px -40px 0px'});
    document.querySelectorAll('.cwb-animate:not(.cwb-visible)').forEach(function(el){ io0.observe(el); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cwb-sticky-atc"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-cwb-sticky]').forEach(function(bar){
    var trigger = document.querySelector('[data-cwb-atc]') || document.querySelector('.product-form__submit, button[name="add"]');
    var select = bar.querySelector('[data-cwb-sticky-select]');
    var priceEl = bar.querySelector('[data-cwb-sticky-price]');
    var atcBtn = bar.querySelector('[data-cwb-sticky-atc]');
    var atcText = bar.querySelector('[data-cwb-sticky-atc-text]');

    function currentVariantId(){
      return select ? select.value : atcBtn.getAttribute('data-variant-id');
    }

    if (select) {
      select.addEventListener('change', function(){
        atcBtn.setAttribute('data-variant-id', select.value);
        var opt = select.options[select.selectedIndex];
        var price = opt.getAttribute('data-price');
        if (price && priceEl) {
          var amount = (parseInt(price, 10) / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
          priceEl.textContent = amount;
        }
      });
    }

    function toggleVisibility(){
      if (!trigger) { bar.classList.add('is-visible'); return; }
      var rect = trigger.getBoundingClientRect();
      bar.classList.toggle('is-visible', rect.bottom < 0);
    }
    window.addEventListener('scroll', toggleVisibility, { passive: true });
    toggleVisibility();

    atcBtn.addEventListener('click', function(){
      var id = currentVariantId();
      if (!id) return;
      atcBtn.disabled = true;
      atcText.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      })
        .then(function(res){ if (!res.ok) throw new Error('add failed'); return res.json(); })
        .then(function(){
          atcText.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(function(){ atcText.textContent = 'Add to Cart'; atcBtn.disabled = false; }, 1500);
        })
        .catch(function(){
          atcText.textContent = 'Error — try again';
          setTimeout(function(){ atcText.textContent = 'Add to Cart'; atcBtn.disabled = false; }, 1500);
        });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cwb-testimonials"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (!window.__cwbFadeInit) {
    window.__cwbFadeInit = true;
    var io0 = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('cwb-visible'); io0.unobserve(e.target); }
      });
    }, {threshold: 0.15, rootMargin: '0px 0px -40px 0px'});
    document.querySelectorAll('.cwb-animate:not(.cwb-visible)').forEach(function(el){ io0.observe(el); });
  }

  document.querySelectorAll('[data-cwb-testi-track]').forEach(function(track){
    var wrap = track.closest('.cwb-testi__slider-wrap');
    var prev = wrap.querySelector('[data-cwb-testi-prev]');
    var next = wrap.querySelector('[data-cwb-testi-next]');
    function scrollByCard(dir){
      var card = track.querySelector('.cwb-testi__card');
      if (!card) return;
      track.scrollBy({ left: dir * (card.getBoundingClientRect().width + 16), behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function(){ scrollByCard(-1); });
    if (next) next.addEventListener('click', function(){ scrollByCard(1); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cwb-transformation-gallery"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (!window.__cwbFadeInit) {
    window.__cwbFadeInit = true;
    var io0 = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('cwb-visible'); io0.unobserve(e.target); }
      });
    }, {threshold: 0.15, rootMargin: '0px 0px -40px 0px'});
    document.querySelectorAll('.cwb-animate:not(.cwb-visible)').forEach(function(el){ io0.observe(el); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cwb-trust-badges"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (!window.__cwbFadeInit) {
    window.__cwbFadeInit = true;
    var io0 = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('cwb-visible'); io0.unobserve(e.target); }
      });
    }, {threshold: 0.15, rootMargin: '0px 0px -40px 0px'});
    document.querySelectorAll('.cwb-animate:not(.cwb-visible)').forEach(function(el){ io0.observe(el); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wbe-buy"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.getElementById('wbe-buy');
  if(!root) return;
  var slides = [].slice.call(root.querySelectorAll('[data-wbe-slide]'));
  var thumbs = [].slice.call(root.querySelectorAll('[data-wbe-thumb]'));
  function show(i){
    slides.forEach(function(s,n){ s.hidden = (n !== i); });
    thumbs.forEach(function(t){ t.setAttribute('aria-current', String(Number(t.dataset.i) === i)); });
  }
  thumbs.forEach(function(t){ t.addEventListener('click', function(){ show(Number(t.dataset.i)); }); });
  var qty = root.querySelector('[data-wbe-qty]');
  var minus = root.querySelector('[data-wbe-minus]');
  var plus = root.querySelector('[data-wbe-plus]');
  if(minus) minus.addEventListener('click', function(){ qty.value = Math.max(1, (parseInt(qty.value,10)||1) - 1); });
  if(plus) plus.addEventListener('click', function(){ qty.value = (parseInt(qty.value,10)||1) + 1; });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wbx-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.getElementById('wbx-hero');
  if(!root) return;
  root.querySelectorAll('[data-wbx-tab]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var key = btn.dataset.wbxTab;
      root.querySelectorAll('[data-wbx-tab]').forEach(function(b){
        var on = b === btn;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-selected', String(on));
      });
      root.querySelectorAll('[data-wbx-pane]').forEach(function(p){
        p.hidden = (p.dataset.wbxPane !== key);
      });
      if (window.wbxTrack) window.wbxTrack('before_after_interaction', { pane: key });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
